import { context, propagation } from '@opentelemetry/api';
import { AxiosRequestConfig } from 'axios';

export function sanitizeUrl(fullUrl: string) {
  try {
    const u = new URL(
      fullUrl,
      typeof window === 'undefined'
        ? 'http://localhost'
        : window.location.origin,
    );
    u.search = '';
    return u.toString();
  } catch {
    return fullUrl.split('?')[0];
  }
}

export function injectTraceHeaders(config: AxiosRequestConfig) {
  const carrier: Record<string, string> = {};
  propagation.inject(context.active(), carrier);

  config.headers = {
    ...config.headers,
    ...carrier,
  };
}
